import {Brick, Predicate, registerBrick} from 'olympe';
import InspectionEntity from '../../../models/InspectionEntity';

export default class IsInspectionCurrentlyAvailableInUnit extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<!InspectionState>} unitStates
     * @param {*} currentInspection
     * @param {function(boolean)} setIsAvailable
     */
    async update($, [unitStates, currentInspection], [setIsAvailable]) {
        // Get presumed states
        const predicate = Predicate.in(...unitStates.values());
        const validStates = currentInspection.follow(InspectionEntity.presumedStatesRel).filter(predicate).executeFromCache($);
        setIsAvailable(validStates.size() > 0);
    }
}

registerBrick('01898d37fc61125a3dcf', IsInspectionCurrentlyAvailableInUnit);
